export default {
  /**
   * Identify if any filters are applied.
   *
   * @param {Object} state
   * @returns {Boolean}
   */
  filtersApplied(state) {
    const created = state.filters.created || {}
    const invoice = state.filters.invoice || {}
    const statuses = state.filters.statuses || null

    return Boolean(created.start || created.end || invoice.start || invoice.end || statuses !== null)
  },
}
